import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["textContent"]

interface Props {
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownLabel',
  props: {
    label: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "ml-auto mr-3",
      textContent: _toDisplayString(props.label)
    }, null, 8 /* PROPS */, _hoisted_2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})